


























import { Component, Vue } from "vue-property-decorator";
import iScalerItem from "./i-scaler-item.vue";

interface IScalerItemDatas {
  image: string;
  title?: string;
  content?: string;
  href?: string;
  base?: string;
}

interface IScalerDatas {
  type: string;
  data: any;
}

@Component({
  components: {
    iScalerItem
  }
})
export default class iScalerViewer extends Vue {
  private fixedStyle: any = "";
  private fixedOuterStyle: any = "";
  private filterBackStyle: any = "";
  private isFixedShow: boolean = false;
  private bounds: any = null;

  private datas: IScalerDatas | null = null;

  private transition: string =
    "width 0.5s cubic-bezier(0.075, 0.82, 0.165, 1),height 0.5s cubic-bezier(0.075, 0.82, 0.165, 1),left 0.5s cubic-bezier(0.075, 0.82, 0.165, 1),top 0.5s cubic-bezier(0.075, 0.82, 0.165, 1), border-radius ease-in-out 0.5s";

  private scaler: HTMLDivElement | null = null;

  created() {
    this.$bus.$on("open-viewer", (data: IScalerDatas, ev: any) => {
      this.datas = data;
      this.openScaler(ev);
    });
  }

  beforeDestroy() {
    this.$bus.$off("open-viewer");
  }

  private closeScaler() {
    if (this.bounds !== null) {
      this.fixedOuterStyle = {
        opacity: 0
      };
      this.filterBackStyle = {
        opacity: 0
      };
      this.fixedStyle = {
        left: this.bounds.left + "px",
        top: this.bounds.top + "px",
        height: this.bounds.height + "px",
        width: this.bounds.width + "px",
        transition: this.transition,
        "border-radius": "var(--border-radius-large)"
      };

      const scalerItem = this.$children[0] as iScalerItem;

      scalerItem.hide(scalerItem);
      setTimeout(() => {
        this.isFixedShow = false;
      }, 500);
    }
  }

  private openScaler(ev: any) {
    if (!this.isFixedShow && this.datas !== null) {
      const bounds = ev.getBoundingClientRect();
      this.bounds = this.$utils.clone(bounds, true);
      this.isFixedShow = true;
      this.fixedStyle = {
        left: bounds.left + "px",
        top: bounds.top + "px",
        height: bounds.height + "px",
        width: bounds.width + "px",
        "border-radius": "var(--border-radius-large)"
      };
      let width: number, left: number;

      if (this.datas.type === "article") {
        width = document.body.clientWidth / 2;
        left = width / 2;
      } else {
        const image = new Image();
        image.src = this.datas.data.image;
        width = (document.body.clientHeight / image.height) * image.width;
        left = (document.body.clientWidth - width) / 2;
      }

      this.$nextTick(() => {
        setTimeout(() => {
          const scalerItem = this.$children[0] as iScalerItem;
          scalerItem.show(scalerItem);
          this.fixedStyle = {
            left: left + "px",
            top: 0,
            height: "100%",
            width: width + "px",
            transition: this.transition,
            "border-radius": "0"
          };
          this.fixedOuterStyle = {
            opacity: 1
          };
          this.filterBackStyle = {
            opacity: 1
          };
        }, 50);
      });
    }
  }
}
